import { render, staticRenderFns } from "./share-modal-settings-passcode.vue?vue&type=template&id=1a6b397a&scoped=true&"
import script from "./share-modal-settings-passcode.vue?vue&type=script&lang=ts&"
export * from "./share-modal-settings-passcode.vue?vue&type=script&lang=ts&"
import style0 from "./share-modal-settings-passcode.vue?vue&type=style&index=0&id=1a6b397a&lang=scss&scoped=true&"
import style1 from "./share-modal-settings-passcode.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b397a",
  null
  
)

export default component.exports